import {required} from "vuelidate/lib/validators";  
const ORenkAciklamalari = {
    data() {
      return { 
        ORenkAciklamalariData:{  
          Renk: "",
          Aciklama: "",
          Deleted:false,
        },
        Renkler: [
          { Id:"0",  Value:"Seçiniz" },
          { Id:"Transparent",  Value:"Transparent" },
          { Id:"AliceBlue",  Value:"AliceBlue" },
          { Id:"AntiqueWhite",  Value:"AntiqueWhite" },
          { Id:"Aqua",  Value:"Aqua" },
          { Id:"Aquamarine",  Value:"Aquamarine" },
          { Id:"Azure",  Value:"Azure" },
          { Id:"Beige",  Value:"Beige" },
          { Id:"Bisque",  Value:"Bisque" },
          { Id:"Black",  Value:"Black" },
          { Id:"BlanchedAlmond",  Value:"BlanchedAlmond" },
          { Id:"Blue",  Value:"Blue" },
          { Id:"BlueViolet",  Value:"BlueViolet" },
          { Id:"Brown",  Value:"Brown" },
          { Id:"BurlyWood",  Value:"BurlyWood" },
          { Id:"CadetBlue",  Value:"CadetBlue" },
          { Id:"Chartreuse",  Value:"Chartreuse" },
          { Id:"Chocolate",  Value:"Chocolate" },
          { Id:"Coral",  Value:"Coral" },
          { Id:"CornflowerBlue",  Value:"CornflowerBlue" },
          { Id:"Cornsilk",  Value:"Cornsilk" },
          { Id:"Crimson",  Value:"Crimson" },
          { Id:"Cyan",  Value:"Cyan" },
          { Id:"DarkBlue",  Value:"DarkBlue" },
          { Id:"DarkCyan",  Value:"DarkCyan" },
          { Id:"DarkGoldenrod",  Value:"DarkGoldenrod" },
          { Id:"DarkGray",  Value:"DarkGray" },
          { Id:"DarkGreen",  Value:"DarkGreen" },
          { Id:"DarkKhaki",  Value:"DarkKhaki" },
          { Id:"DarkMagenta",  Value:"DarkMagenta" },
          { Id:"DarkOliveGreen",  Value:"DarkOliveGreen" },
          { Id:"DarkOrange",  Value:"DarkOrange" },
          { Id:"DarkOrchid",  Value:"DarkOrchid" },
          { Id:"DarkRed",  Value:"DarkRed" },
          { Id:"DarkSalmon",  Value:"DarkSalmon" },
          { Id:"DarkSeaGreen",  Value:"DarkSeaGreen" },
          { Id:"DarkSlateBlue",  Value:"DarkSlateBlue" },
          { Id:"DarkSlateGray",  Value:"DarkSlateGray" },
          { Id:"DarkTurquoise",  Value:"DarkTurquoise" },
          { Id:"DarkViolet",  Value:"DarkViolet" },
          { Id:"DeepPink",  Value:"DeepPink" },
          { Id:"DeepSkyBlue",  Value:"DeepSkyBlue" },
          { Id:"DimGray",  Value:"DimGray" },
          { Id:"DodgerBlue",  Value:"DodgerBlue" },
          { Id:"Firebrick",  Value:"Firebrick" },
          { Id:"FloralWhite",  Value:"FloralWhite" },
          { Id:"ForestGreen",  Value:"ForestGreen" },
          { Id:"Fuchsia",  Value:"Fuchsia" },
          { Id:"Gainsboro",  Value:"Gainsboro" },
          { Id:"GhostWhite",  Value:"GhostWhite" },
          { Id:"Gold",  Value:"Gold" },
          { Id:"Goldenrod",  Value:"Goldenrod" },
          { Id:"Gray",  Value:"Gray" },
          { Id:"Green",  Value:"Green" },
          { Id:"GreenYellow",  Value:"GreenYellow" },
          { Id:"Honeydew",  Value:"Honeydew" },
          { Id:"HotPink",  Value:"HotPink" },
          { Id:"IndianRed",  Value:"IndianRed" },
          { Id:"Indigo",  Value:"Indigo" },
          { Id:"Ivory",  Value:"Ivory" },
          { Id:"Khaki",  Value:"Khaki" },
          { Id:"Lavender",  Value:"Lavender" },
          { Id:"LavenderBlush",  Value:"LavenderBlush" },
          { Id:"LawnGreen",  Value:"LawnGreen" },
          { Id:"LemonChiffon",  Value:"LemonChiffon" },
          { Id:"LightBlue",  Value:"LightBlue" },
          { Id:"LightCoral",  Value:"LightCoral" },
          { Id:"LightCyan",  Value:"LightCyan" },
          { Id:"LightGoldenrodYellow",  Value:"LightGoldenrodYellow" },
          { Id:"LightGreen",  Value:"LightGreen" },
          { Id:"LightGray",  Value:"LightGray" },
          { Id:"LightPink",  Value:"LightPink" },
          { Id:"LightSalmon",  Value:"LightSalmon" },
          { Id:"LightSeaGreen",  Value:"LightSeaGreen" },
          { Id:"LightSkyBlue",  Value:"LightSkyBlue" },
          { Id:"LightSlateGray",  Value:"LightSlateGray" },
          { Id:"LightSteelBlue",  Value:"LightSteelBlue" },
          { Id:"LightYellow",  Value:"LightYellow" },
          { Id:"Lime",  Value:"Lime" },
          { Id:"LimeGreen",  Value:"LimeGreen" },
          { Id:"Linen",  Value:"Linen" },
          { Id:"Magenta",  Value:"Magenta" },
          { Id:"Maroon",  Value:"Maroon" },
          { Id:"MediumAquamarine",  Value:"MediumAquamarine" },
          { Id:"MediumBlue",  Value:"MediumBlue" },
          { Id:"MediumOrchid",  Value:"MediumOrchid" },
          { Id:"MediumPurple",  Value:"MediumPurple" },
          { Id:"MediumSeaGreen",  Value:"MediumSeaGreen" },
          { Id:"MediumSlateBlue",  Value:"MediumSlateBlue" },
          { Id:"MediumSpringGreen",  Value:"MediumSpringGreen" },
          { Id:"MediumTurquoise",  Value:"MediumTurquoise" },
          { Id:"MediumVioletRed",  Value:"MediumVioletRed" },
          { Id:"MidnightBlue",  Value:"MidnightBlue" },
          { Id:"MintCream",  Value:"MintCream" },
          { Id:"MistyRose",  Value:"MistyRose" },
          { Id:"Moccasin",  Value:"Moccasin" },
          { Id:"NavajoWhite",  Value:"NavajoWhite" },
          { Id:"Navy",  Value:"Navy" },
          { Id:"OldLace",  Value:"OldLace" },
          { Id:"Olive",  Value:"Olive" },
          { Id:"OliveDrab",  Value:"OliveDrab" },
          { Id:"Orange",  Value:"Orange" },
          { Id:"OrangeRed",  Value:"OrangeRed" },
          { Id:"Orchid",  Value:"Orchid" },
          { Id:"PaleGoldenrod",  Value:"PaleGoldenrod" },
          { Id:"PaleGreen",  Value:"PaleGreen" },
          { Id:"PaleTurquoise",  Value:"PaleTurquoise" },
          { Id:"PaleVioletRed",  Value:"PaleVioletRed" },
          { Id:"PapayaWhip",  Value:"PapayaWhip" },
          { Id:"PeachPuff",  Value:"PeachPuff" },
          { Id:"Peru",  Value:"Peru" },
          { Id:"Pink",  Value:"Pink" },
          { Id:"Plum",  Value:"Plum" },
          { Id:"PowderBlue",  Value:"PowderBlue" },
          { Id:"Purple",  Value:"Purple" },
          { Id:"Red",  Value:"Red" },
          { Id:"RosyBrown",  Value:"RosyBrown" },
          { Id:"RoyalBlue",  Value:"RoyalBlue" },
          { Id:"SaddleBrown",  Value:"SaddleBrown" },
          { Id:"Salmon",  Value:"Salmon" },
          { Id:"SandyBrown",  Value:"SandyBrown" },
          { Id:"SeaGreen",  Value:"SeaGreen" },
          { Id:"SeaShell",  Value:"SeaShell" },
          { Id:"Sienna",  Value:"Sienna" },
          { Id:"Silver",  Value:"Silver" },
          { Id:"SkyBlue",  Value:"SkyBlue" },
          { Id:"SlateBlue",  Value:"SlateBlue" },
          { Id:"SlateGray",  Value:"SlateGray" },
          { Id:"Snow",  Value:"Snow" },
          { Id:"SpringGreen",  Value:"SpringGreen" },
          { Id:"SteelBlue",  Value:"SteelBlue" },
          { Id:"Tan",  Value:"Tan" },
          { Id:"Teal",  Value:"Teal" },
          { Id:"Thistle",  Value:"Thistle" },
          { Id:"Tomato",  Value:"Tomato" },
          { Id:"Turquoise",  Value:"Turquoise" },
          { Id:"Violet",  Value:"Violet" },
          { Id:"Wheat",  Value:"Wheat" },
          { Id:"White",  Value:"White" },
          { Id:"WhiteSmoke",  Value:"WhiteSmoke" },
          { Id:"Yellow",  Value:"Yellow" },
          { Id:"YellowGreen",  Value:"YellowGreen" },
        ],    
          FormDataType:{
            Renk:{FieldName:"Renk",Field:"combobox",FieldTitle:this.$t('ORenkAciklamalari.AddEdit.Renk'),ComboDataArray:[]},
            Aciklama:{FieldName:"Icerik",Field:"textarea",FieldTitle:this.$t('ORenkAciklamalari.AddEdit.Aciklama')},

          }  
      } 
    },
    validations:{ 
      FormData: {
        Renk: { required },  
        Aciklama: { required }, 
    
      } 
  },


  created(){ 
    
          for(var i=0; i<this.Renkler.length; i++)
          {
              this.FormDataType.Renk.ComboDataArray.push ({Id:this.Renkler[i].Id,Value:this.Renkler[i].Value})
        
          }
    
  }

}
export default ORenkAciklamalari